import script from "./OurRestaurants.vue?vue&type=script&setup=true&lang=js"
export * from "./OurRestaurants.vue?vue&type=script&setup=true&lang=js"

import "./OurRestaurants.vue?vue&type=style&index=0&id=031fb17b&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-031fb17b"]])

export default __exports__